<div class="label-dialog-container">
  
  <h3>Upload Return Label - IMEI {{ data.imei }}</h3>

  <form [formGroup]="returnLabelForm" class="upload-section">

    <mat-form-field appearance="outline">
      <mat-label>Return Carrier</mat-label>
      <mat-select formControlName="carrier">
        <mat-option value="fedex">FedEx</mat-option>
        <mat-option value="ups">UPS</mat-option>
        <mat-option value="usps">USPS</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="file-upload-container">
      <button mat-raised-button color="accent" type="button"
              (click)="openReturnLabelFileDialog($event)"
              [disabled]="isUploadingReturnLabel">
        <mat-icon>file_upload</mat-icon>
        {{ returnLabelFile ? 'Change File' : 'Select File' }}
      </button>

      <mat-spinner *ngIf="isUploadingReturnLabel" diameter="24"></mat-spinner>

      <input #returnLabelInput type="file" accept=".pdf,.png,.jpg,.jpeg"
             (change)="onReturnLabelFileSelected($event)" hidden />
    </div>

    <div *ngIf="returnLabelFile && !isUploadingReturnLabel" class="file-info">
      <mat-icon>attach_file</mat-icon>
      <span>{{ returnLabelFileName }}</span>
      <button mat-icon-button color="warn" (click)="removeReturnLabel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </form>

  <mat-divider></mat-divider>

  <h3 class="section-title">Existing Return Labels</h3>

  <div *ngIf="loadingLabels" class="loading-center">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <div *ngIf="!loadingLabels && labels.length === 0" class="empty">
    <span>No active return labels found</span>
</div>
<mat-list *ngIf="labels.length > 0" class="labels-list">
    <mat-list-item *ngFor="let label of labels" class="label-item">

        <div class="label-text">
            
            <a [href]="label.url" target="_blank" class="label-title">
                {{ label.title }}
            </a>

            <div class="label-meta">
                Carrier: {{ formatCarrier(label.carrier) }} - {{ label.createdAt | date:'short' }}
            </div>
        </div>

        <button mat-icon-button color="warn" (click)="deleteLabel(label)">
            <mat-icon>delete</mat-icon>
        </button>

    </mat-list-item>
</mat-list>

<div class="modal-actions">
    <button mat-stroked-button color="default" (click)="closeDialog()">Close</button>
  </div>

</div>
